import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsPage.vue?vue&type=style&index=0&id=17bafc16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bafc16"]])

export default __exports__